var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "characteristic-desire-experience" },
    [
      _vm._t("info-text"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("RadioGroup", {
            attrs: { options: _vm.typeOptions },
            on: { input: _vm.typeChanged },
            model: {
              value: _vm.type,
              callback: function($$v) {
                _vm.type = $$v
              },
              expression: "type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.typeIsYes
        ? _c("div", { staticClass: "my-3" }, [_vm._t("yes-text")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.typeIsIrrelevant
        ? _c("div", { staticClass: "my-3" }, [_vm._t("irrelevant-text")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.type && _vm.experienceEligible
        ? _c(
            "div",
            { staticClass: "characteristic-desire-experience--items" },
            _vm._l(_vm.characteristicItems, function(characteristic) {
              return _c(
                "div",
                {
                  key: characteristic.id,
                  staticClass: "characteristic-desire-experience--item"
                },
                [
                  _c(
                    "b-row",
                    { attrs: { "align-v": "center" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "5" } },
                        [
                          _vm.typeIsNo
                            ? [
                                _c("Label", {
                                  attrs: { characteristic: characteristic }
                                }),
                                _vm._v(" "),
                                characteristic.description
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.html",
                                            modifiers: { html: true }
                                          }
                                        ],
                                        staticClass:
                                          "characteristic-desire-experience--item-description",
                                        attrs: {
                                          title: characteristic.description
                                        }
                                      },
                                      [_c("Icon", { attrs: { icon: "info" } })],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      checked: _vm.isDesired(characteristic)
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.desireChanged(
                                          characteristic,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("Label", {
                                      attrs: { characteristic: characteristic }
                                    }),
                                    _vm._v(" "),
                                    characteristic.description
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.html",
                                                modifiers: { html: true }
                                              }
                                            ],
                                            staticClass:
                                              "characteristic-desire-experience--item-description",
                                            attrs: {
                                              title: characteristic.description
                                            }
                                          },
                                          [
                                            _c("Icon", {
                                              attrs: { icon: "info" }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-2 mt-md-0", attrs: { md: "7" } },
                        [
                          _c("Select", {
                            attrs: {
                              value: _vm.getExperience(characteristic),
                              options: _vm.experienceOptions,
                              "empty-value-label":
                                "Bitte triff eine Auswahl, ob du bereits Erfahrung hast",
                              smaller: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.experienceChanged(
                                  characteristic,
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }